import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import './TopicEditModal.css';

interface TopicEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (topic: string) => void;
  currentTopic: string;
}

const TopicEditModal: React.FC<TopicEditModalProps> = ({
  isOpen,
  onClose,
  onSave,
  currentTopic
}) => {
  const [topic, setTopic] = useState(currentTopic);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (isOpen) {
      setTopic(currentTopic);
      // Focus the input when modal opens
      setTimeout(() => {
        inputRef.current?.focus();
        inputRef.current?.select();
      }, 100);
    }
  }, [isOpen, currentTopic]);

  const handleSave = () => {
    if (topic.trim()) {
      onSave(topic.trim());
      onClose();
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleInputPointerDown = (e: React.PointerEvent) => {
    // Prevent backdrop click when interacting with input
    e.stopPropagation();
  };

  const handleModalPointerDown = (e: React.PointerEvent) => {
    // Prevent any dragging behavior when modal is open
    e.stopPropagation();
  };

  if (!isOpen) return null;

  const modal = (
    <div className="topic-edit-modal-backdrop" onClick={handleBackdropClick}>
      <div className="topic-edit-modal" onPointerDown={handleModalPointerDown}>
        <div className="topic-edit-modal-content">
          <h3>Edit Topic</h3>
          <input
            ref={inputRef}
            type="text"
            value={topic}
            onChange={(e) => setTopic(e.target.value)}
            onKeyDown={handleKeyDown}
            onPointerDown={handleInputPointerDown}
            placeholder="Enter topic..."
            className="topic-edit-input"
          />
          <div className="topic-edit-actions">
            <button 
              className="topic-edit-ok-btn"
              onClick={handleSave}
              disabled={!topic.trim()}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, document.body);
};

export default TopicEditModal; 